export default __webpack_public_path__ + "img/login.9c1ecd37.jpg";